import useCourseDetailsApi from './useCourseDetailsApi';

const useCourseDetails = ({ courseId } = {}) => {
  const { course, loading } = useCourseDetailsApi({ courseId });

  return {
    course,
    loading,
  };
};

export default useCourseDetails;
